/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ElementInView from 'components_v2/common/ElementInView/ElementInView';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import {
  setPageConfigAndSendIBeatCall,
  setIbeattrack,
} from 'utils/iBeatConfig';
import {
  reloadIfPaidStory,
  setVariableForResizeObserver,
  // isPrimeUser,
  // reloadWrtPrimeUnlock,
  // setViewedArticleMsidsInLocalStorage,
  enableNewGooglExtended,
  // getQueryParams,
  fireGA4Script,
  fireGA4WithDataObject,
} from 'utils/common';
import BannerBenefits from 'components_v3/BannerBenefits/BannerBenefits.tsx';
// import PEEntryNudge from 'components_v3/PEEntryNudge/PEEntryNudge.tsx';
// import AppAccessPrimeshow from 'components_v3/AppAccessPrimeshow/AppAccessPrimeshow.tsx';
import ToipNudges from 'components_v2/common/ToipNudges';
import Blockerscreen from 'components/Blockerscreen/Blockerscreen';
import _get from 'lodash.get';
import FAQ from './../PlanFaq/PlanFaq';
import {
  fetchUserSubscriptionStatusFromApi,
  isStoryPageNewVariant,
  getPrcCookieValue,
  getCollatedPropvalue,
} from 'utils/primeUtil';
// import { fetchUserSubscriptionStatusFromApi } from 'utils/primeUtil';
import GoogleEAFlow from 'components_v2/common/GoogleEAFlow/GoogleEAFlow';
import GoogleEAFlowNew from 'components_v2/common/GoogleEAFlow/GoogleEAFlowNew';
import ClientOnly from '../ClientOnly';
import StoryCard from '../StoryCard/StoryCard';
import RightSection from '../RightSection/RightSection';
import StoryBlockerPopUp from '../../../../../components_v2/common/ToipNudges/StoryBlockerV3/StoryBlockerPopUp';
// import BannerSection from '../BannerSection/BannerSection';
// import BundleSection from '../BundleSection/BundleSection';
import s from './Primeshow.scss';
import {
  // Plan,
  PRC_FOR_FTU,
  PRC_FOR_SUBSCRIBED,
  TOI_DEV_DOMAIN,
  TOI_LIVE_DOMAIN,
} from '../../../../../constants';
import PersonaliseWidget from '../../../../../components_v2/common/PersonaliseWidget/PersonaliseWidget';

const pageType = 'toiplusprimeshow';

const Primeshow = props => {
  // const [selectedPlanOption, setSelectedPlanOption] = useState(
  //   Plan.DEFAULT_PLAN,
  // );
  // const onPlanOptionSelect = option => {
  //   setSelectedPlanOption(option);
  // };

  const {
    isWapView,
    msid,
    userData,
    isAppView,
    // location,
    articleData,
    hideToiPlusBlockerScreen,
    storyTitle,
    // cardsData,
    // isPrime,
    isToiPlusAllowReadOnly,
    translationData,
    userPrcData,
    // peEntryNudgeData,
    // appAccessPrimeshowData,
    showFreeTrailBlocker,
  } = props;

  let ATF_WRAPPER_HEIGHT = 0;
  let ATF_MOBILE_ADS_PADDING = 0;
  //const [paidstories, setStories] = useState(false);
  // const [bundleDataCheck, setbundleDataCheck] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const closePopUpRef = useRef();
  const checkPaidStories = () => {
    if (
      userData &&
      userData.isLoggedIn &&
      userData.prcValue !== PRC_FOR_FTU &&
      userData.prcValue !== PRC_FOR_SUBSCRIBED &&
      userPrcData
    ) {
      fetchUserSubscriptionStatusFromApi(userPrcData).then(data => {
        if (data?.data) {
          reloadIfPaidStory(msid);
        }
      });
    } else {
      //setStories(false);
    }
  };

  const shouldShowPopUp = val => {
    setShowPopUp(val);
  };

  const getSectionName = () => {
    // optimise code and common file
    const sectionName =
      articleData[msid].navsubsecs &&
      articleData[msid].navsubsecs.subsec1 &&
      articleData[msid].navsubsecs.subsec1.subsecname1
        ? articleData[msid].navsubsecs.subsec1.subsecname1
        : '';

    return sectionName;
  };

  useEffect(
    () => {
      // if (isPrimeUser()) {
      //   if (!__PROD__) {
      //     // reloadWrtPrimeUnlock();
      //   }
      // } else {
      //   checkPaidStories();
      // }
      checkPaidStories();
    },
    [userData, userPrcData],
  );
  const transformElementsByPixel = height => {
    const contentWrapperMobileObj = document.querySelector('.wrapperclearfix');
    if (contentWrapperMobileObj) {
      contentWrapperMobileObj.style.transform = `translateY(${height}px)`;
      contentWrapperMobileObj.style.marginBottom = `${height}px`;
    }
  };
  const observeResizeChange = elem => {
    const resizeObserver = new ResizeObserver(resizedEntry => {
      try {
        if (resizedEntry[0].contentRect.height > ATF_MOBILE_ADS_PADDING) {
          const resizedHeight =
            resizedEntry[0].contentRect.height - ATF_WRAPPER_HEIGHT;
          transformElementsByPixel(resizedHeight);
        }
      } catch (e) {
        console.log(e);
      }
    });
    resizeObserver.observe(elem);
    // The following code is to just ensure that if the div is loaded with height already greater
    // than 50px before resize observer is initialized, it will take care of it
    // It will run only once while the observer is initialized
    if (elem.offsetHeight > ATF_MOBILE_ADS_PADDING) {
      const resizedHeight = elem.offsetHeight - ATF_WRAPPER_HEIGHT;
      transformElementsByPixel(resizedHeight);
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined' && articleData && articleData[msid]?.wu) {
      let pageViewUrl = null;
      if (isWapView) {
        pageViewUrl = articleData[msid].wu.replace(
          TOI_DEV_DOMAIN,
          TOI_LIVE_DOMAIN,
        );
      } else if (!isWapView) {
        pageViewUrl = articleData[msid].wu.replace(
          TOI_DEV_DOMAIN,
          TOI_LIVE_DOMAIN,
        );
      }
      if (pageViewUrl) {
        analyticsWrapper('ga', 'send', 'pageview', pageViewUrl);
        fireGA4WithDataObject(
          fireGA4Script({ vmsid: msid, isToipLayout: true }) || {},
        );
      }
    }
    const {
      atfWrapperHeight,
      atfMobileAdsPadding,
    } = setVariableForResizeObserver();
    ATF_WRAPPER_HEIGHT = atfWrapperHeight;
    ATF_MOBILE_ADS_PADDING = atfMobileAdsPadding;
    const atfMobileObj = document.querySelector('.ATF_mobile_ads');
    if (
      typeof window !== 'undefined' &&
      window.TimesApps &&
      typeof window.TimesApps.initCLSHandling === 'function'
    ) {
      window.TimesApps.initCLSHandling();
    } else if (atfMobileObj && typeof ResizeObserver !== 'undefined') {
      observeResizeChange(atfMobileObj);
    }
    setIbeattrack({
      author: getCollatedPropvalue(articleData?.[msid]?.authors, 'name'),
      contentType: 1,
      msid,
      planStatus: getPrcCookieValue(),
      publishedDate: articleData?.[msid]?.dl,
    });
    setPageConfigAndSendIBeatCall();
  }, []);

  const gaCategory = isWapView ? 'wap-newprimeshow' : 'web-newprimeshow';
  const isLoggedIn =
    userData && userData.isLoggedIn ? userData.isLoggedIn : undefined;
  const prcValue = userData && userData.prcValue ? userData.prcValue : 0;

  const fireGA = gaAction => {
    if (typeof window !== 'undefined') {
      analyticsWrapper(
        'ga',
        'send',
        'event',
        gaCategory,
        gaAction,
        `Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`,
      );
    }
  };

  const checkShowcaseUrl = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    return (
      Object.keys(params).length !== 0 && params.utm_source === 'newsshowcase'
    );
  };
  // const getSubsectionUrl = () => {
  //   const urlPathParams = location.split('/');
  //   if (urlPathParams.indexOf('articleshow') > -1) {
  //     const articleShowIndex = urlPathParams.indexOf('articleshow');
  //     const subSection = urlPathParams
  //       .splice(0, articleShowIndex - 1)
  //       .join('/');
  //     return subSection;
  //   }
  //   return null;
  // };

  // const subSectionUrl = getSubsectionUrl();
  // const checkingBundleData = () => {
  //   setbundleDataCheck(true);
  // };

  const getReadNextWidget = () => (
    <PersonaliseWidget
      card={isWapView ? 'readNextColumnVariant' : 'readNextRowVariant'}
      section={getSectionName() || ''}
      subsection={_get(articleData?.navsubsecs?.subsec2, 'subsecname2', '')}
      msid={msid}
      template="AS"
      contentprimestatus="prime"
      userprimestatus="non-prime"
      styleObj={{
        minHeight: isWapView ? '356px' : '246px',
        margin: isWapView ? '20px 0px 20px 16px' : '',
      }}
      classname="toipreadnextshimmer"
      isWapView={isWapView}
    />
  );

  // const getPeEntryNudgeData = () =>
  //   peEntryNudgeData?.[`prc${userData?.prcValue}`];
  // const getAppAccessPrimeshowData = () =>
  //   appAccessPrimeshowData?.[userData?.prcValue];

  const getBlockerHtml = () => (
    <div id="story-blocker-new">
      <ToipNudges
        viewType="toiplusprimeshowV3"
        isWapView={isWapView}
        msid={msid}
        isAppView={isAppView}
        userData={userData}
        storyTitle={storyTitle}
        shouldShowPopUp={shouldShowPopUp}
        showFreeTrailBlocker={showFreeTrailBlocker}
        blockerPopUp={false}
      />
    </div>
  );

  return (
    <>
      {typeof window !== 'undefined' &&
        checkShowcaseUrl() &&
        !enableNewGooglExtended() && (
          <GoogleEAFlow storymsid={msid} isWapView={isWapView} />
        )}
      {typeof window !== 'undefined' &&
        checkShowcaseUrl() &&
        enableNewGooglExtended() && (
          <GoogleEAFlowNew storymsid={msid} isWapView={isWapView} />
        )}
      <Blockerscreen showToiPlusPlanPage={hideToiPlusBlockerScreen} />
      <div className="clearfix rel">
        {!isWapView ? (
          <div className={s.primeshow}>
            {isStoryPageNewVariant() ? (
              <div className={s.storyblockernewWrapper}>
                <article>
                  <StoryCard
                    msid={msid}
                    isWapView={isWapView}
                    pageType={pageType}
                    userData={userData}
                  />
                </article>
              </div>
            ) : (
              <ClientOnly>
                <div>
                  <div className={s.row}>
                    <div className={s.leftColumn}>
                      <StoryCard
                        msid={msid}
                        isWapView={isWapView}
                        pageType={pageType}
                        userData={userData}
                      />
                    </div>
                    <div className={s.rightColumn}>
                      <RightSection msid={msid} />
                    </div>
                  </div>
                </div>
              </ClientOnly>
            )}
            {getBlockerHtml()}
            {getReadNextWidget()}
            {/* {peEntryNudgeData.activeWidget === 'yes' && (
              <ElementInView
                gaCategory={gaCategory}
                gaAction="Print_story_View"
                gaLabel={`Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`}
              >
                <PEEntryNudge
                  isWapView={isWapView}
                  data={getPeEntryNudgeData()}
                  userData={userData}
                  gaCategory={gaCategory}
                  gaAction="Print_story_Click"
                />
              </ElementInView>
            )} */}
            <ElementInView
              gaCategory={gaCategory}
              gaAction="View_whytoiplus"
              gaLabel={`Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`}
            >
              {/* <BannerSection
                fireGA={fireGA}
                isWapView={isWapView}
                msid={msid}
                storyTitle={storyTitle}
              /> */}
              {!isToiPlusAllowReadOnly && (
                <BannerBenefits
                  fireGA={fireGA}
                  msid={msid}
                  storyTitle={storyTitle}
                  isWapView={isWapView}
                />
              )}
            </ElementInView>
          </div>
        ) : (
          <div
            className="wrapperclearfix"
            data-translate-el="1"
            data-translate-id="cw"
          >
            <div className={s.mobile}>
              {isStoryPageNewVariant() ? (
                <article>
                  <StoryCard
                    msid={msid}
                    isWapView={isWapView}
                    pageType={pageType}
                    fireGA={fireGA}
                    userData={userData}
                  />
                </article>
              ) : (
                <ClientOnly>
                  <div>
                    <StoryCard
                      msid={msid}
                      isWapView={isWapView}
                      pageType={pageType}
                      fireGA={fireGA}
                      userData={userData}
                    />
                  </div>
                </ClientOnly>
              )}
              {/* <ElementInView
                gaCategory="mweb-newprimeshow"
                gaAction="mwebtoapp_View"
                gaLabel={`Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`}
              >
                <AppAccessPrimeshow
                  isWapView={isWapView}
                  msid={msid}
                  data={getAppAccessPrimeshowData()}
                  userData={userData}
                  gaCategory="mweb-newprimeshow"
                  gaAction="mwebtoapp_Click"
                />
              </ElementInView> */}
              {getBlockerHtml()}
              {getReadNextWidget('above-bottom-of-article')}
              {/* {peEntryNudgeData.activeWidget === 'yes' && (
                <ElementInView
                  gaCategory={gaCategory}
                  gaAction="Print_story_View"
                  gaLabel={`Ps-${
                    !isLoggedIn && prcValue === 0 ? -1 : prcValue
                  }`}
                >
                  <PEEntryNudge
                    isWapView={isWapView}
                    data={getPeEntryNudgeData()}
                    userData={userData}
                    gaCategory={gaCategory}
                    gaAction="Print_story_Click"
                  />
                </ElementInView>
              )} */}
              <ElementInView
                gaCategory={gaCategory}
                gaAction="View_whytoiplus"
                gaLabel={`Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`}
              >
                {/* <BannerSection
                  fireGA={fireGA}
                  isWapView={isWapView}
                  msid={msid}
                  storyTitle={storyTitle}
                /> */}
                {!isToiPlusAllowReadOnly && (
                  <BannerBenefits
                    fireGA={fireGA}
                    msid={msid}
                    storyTitle={storyTitle}
                    isWapView={isWapView}
                  />
                )}
              </ElementInView>
            </div>
            {isWapView && (
              <FAQ
                supportData={translationData?.supportData}
                faq={translationData?.faq}
              />
            )}
          </div>
        )}
        {!isWapView && (
          <FAQ
            supportData={translationData?.supportData}
            faq={translationData?.faq}
          />
        )}
      </div>
      {showPopUp &&
        !showFreeTrailBlocker && (
          <StoryBlockerPopUp
            isWapView={isWapView}
            msid={msid}
            closePopUpRef={closePopUpRef}
          >
            <ToipNudges
              viewType="toiplusprimeshowV3"
              isWapView={isWapView}
              msid={msid}
              isAppView={isAppView}
              userData={userData}
              storyTitle={storyTitle}
              shouldShowPopUp={shouldShowPopUp}
              blockerPopUp
              showFreeTrailBlocker={false}
              closePopUpRef={closePopUpRef}
            />
          </StoryBlockerPopUp>
        )}
    </>
  );
};

const mapStateToProps = (state, ownProps) => ({
  translationData: _get(state, 'translationConfig.nudges', {}),
  // peEntryNudgeData: _get(state, 'translationConfig.nudges.peEntryNudge', {}),
  // appAccessPrimeshowData: _get(
  //   state,
  //   'translationConfig.nudges.appAccessPrimeshow',
  //   {},
  // ),

  hideToiPlusBlockerScreen: _get(
    state,
    'toiplusconfig.hideToiPlusBlockerScreen',
    true,
  ),
  articleData: state.toiplusprimeshow.data,
  userData: state.login.userData,
  isPrime: state.isPrime,
  primeId: state?.toiplusprimeshow?.data[ownProps.msid]?.primeid,
  cardsData: _get(state, 'readnextbundle.readNextCards', {}),
  isToiPlusAllowReadOnly: state.toiplusconfig?.isToiPlusAllowReadOnly,
  userPrcData: state.login.userPrcData,
  personalizeWidgetData: _get(state, 'personalizeData.widgetData', {}),
  showFreeTrailBlocker: _get(
    state,
    'translationConfig.nudges.storyBlockerNewPaywall.showFreeTrailBlocker',
    false,
  ),
});

Primeshow.propTypes = {
  translationData: PropTypes.shape({}).isRequired,
  isWapView: PropTypes.bool,
  msid: PropTypes.string,
  // location: PropTypes.string,
  storyTitle: PropTypes.string,
  isToiPlusAllowReadOnly: PropTypes.bool,
  showFreeTrailBlocker: PropTypes.bool,
};

Primeshow.defaultProps = {
  isWapView: false,
  msid: '',
  // location: '',
  storyTitle: '',
  isToiPlusAllowReadOnly: false,
  showFreeTrailBlocker: false,
};

export default connect(mapStateToProps, null)(Primeshow);
